import { createSelector } from 'reselect'
import { AdServerInitialStateType } from '../reducers/adServer'

// PLOP_APPEND_PATTERN_ANCHOR
// Get ad server list
type AdServerType = { adServer: AdServerInitialStateType }

export const adServerListSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerList.results,
  results => results
)

export const adServerListIsLoadingSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerList.isLoading,
  isLoading => isLoading
)

export const adServerListErrorSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerList.error,
  error => error
)

export const adServerListWasLoadedSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerList.wasLoaded,
  wasLoaded => wasLoaded
)

// Create ad server
export const createAdServerSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.createAdServer.data,
  data => data
)

export const createAdServerIsLoadingSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.createAdServer.isLoading,
  isLoading => isLoading
)

export const createAdServerErrorSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.createAdServer.error,
  error => error
)

export const createAdServerWasCreatedSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.createAdServer.wasCreated,
  wasCreated => wasCreated
)

// Update ad server
export const updateAdServerSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.updateAdServer,
  updateAdServer => updateAdServer
)

export const updateAdServerIsLoadingSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.updateAdServer.isLoading,
  isLoading => isLoading
)

export const updateAdServerErrorSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.updateAdServer.error,
  error => error
)

export const updateAdServerWasUpdatedSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.updateAdServer.wasUpdated,
  wasUpdated => wasUpdated
)

// Get ad server line items
export const adServerLineItemsSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerLineItems.results,
  results => results
)

export const adServerLineItemsIsLoadingSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerLineItems.isLoading,
  isLoading => isLoading
)

export const adServerLineItemsErrorSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerLineItems.error,
  error => error
)

export const adServerLineItemsWasLoadedSelector = createSelector(
  ({ adServer }: AdServerType) => adServer.adServerLineItems.wasLoaded,
  wasLoaded => wasLoaded
)
